module.exports = __webpack_public_path__ + "static/media/SWSCRC6-54.ff0e77cd.mp3";